module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_112.5deg.d1c9b105.png";